/**
 * 接口域名的管�
 * create by lvzhiyangVUE_APP_BASE_API_domain='ts.st315.cn'
# navbar外链
VUE_APP_BASE_API = 'http://ts.st315.cn'
 */
const base = {
     // dv:'http://172.16.10.162',  // 测试环境
     dv:'https://h.st315.cn',  // 生产环境
     signature:'jEK8BOOEhSeeVJewlSOcqtuGWjVDugAb',
     pr: '', // 生产环境
     mock:'https://easy-mock.com/mock/5cb4762ae14be30f81aee1a6/mock' // mock环境
}
export default base;
